import { render, staticRenderFns } from "./EventsHeader.vue?vue&type=template&id=c94a62fa&"
import script from "./EventsHeader.vue?vue&type=script&lang=js&"
export * from "./EventsHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports